// extracted by mini-css-extract-plugin
export default {"primary":"styles_primary__Ccvbx","secondary":"styles_secondary__WtJBH","negative":"styles_negative__+UcJt"};